const PT_BR = "pt-BR";

const numberFormatter = new Intl.NumberFormat(PT_BR, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

const currencyFormatter = new Intl.NumberFormat(PT_BR, {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const percentFormatter = new Intl.NumberFormat(PT_BR, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

const compactCurrencyFormatter = new Intl.NumberFormat(PT_BR, {
    style: "currency",
    currency: "BRL",
    notation: "compact",
    maximumFractionDigits: 1,
});

const compactNumberFormatter = new Intl.NumberFormat(PT_BR, {
    notation: "compact",
    maximumFractionDigits: 1,
});

/** Número com separador de milhar pt-BR (ex.: 1.000.000 ou 1.234,56). */
export const formatNumberPtBR = (value: number): string => {
    if (!Number.isFinite(value)) return "";
    return numberFormatter.format(value);
};

/** Valor monetário em reais (ex.: R$ 1.000.000,00). */
export const formatCurrencyBRL = (value: number): string => {
    if (!Number.isFinite(value)) return "";
    return currencyFormatter.format(value);
};

/** Percentual já em escala 0–100 (ex.: 30,5%). */
export const formatPercentPtBR = (value: number): string => {
    if (!Number.isFinite(value)) return "";
    return `${percentFormatter.format(value)}%`;
};

/** Valor monetário compacto em reais (ex.: R$ 1,2 mi). Uso em eixos e stat tiles. */
export const formatCompactCurrencyBRL = (value: number): string => {
    if (!Number.isFinite(value)) return "";
    return compactCurrencyFormatter.format(value);
};

/** Número compacto com separador pt-BR (ex.: 1,2 mil). Uso em eixos e stat tiles. */
export const formatCompactNumberPtBR = (value: number): string => {
    if (!Number.isFinite(value)) return "";
    return compactNumberFormatter.format(value);
};

export const coerceToFiniteNumber = (value: unknown): number | null => {
    if (typeof value === "number" && Number.isFinite(value)) return value;
    if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return null;
        const n = Number(trimmed);
        return Number.isFinite(n) ? n : null;
    }
    return null;
};
